import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {BENUTZER_BERECHTIGUNGEN_ENTFERNEN, BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN, BenutzerberechtigungenEntfernenAction, BenutzerberechtigungenHinzufuegenAction, PAGE_DATEN_LADEN, PageLoadDataAction} from './aufgaben-berechtigungen-checklisten.actions.ui';
import {GetFunktionsbereichAufgabenBenutzerBerechtigungenAction, PostAufgabenBenutzerBerechtigungenHinzufuegenAction, PostAufgabenBenutzerBerechtigungenEntfernenAction} from '../../../../client-ngrx/vorlagen';
import {getSelectedAufgaben} from './aufgaben-berechtigungen-checklisten.selectors';
import {AufgabenBenutzerIdsRequest} from '../../../../clients/vorlagen';


@Injectable()
export class AufgabenBerechtigungenChecklistenPageUiEffects {
    datenLaden$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<PageLoadDataAction>(PAGE_DATEN_LADEN),
        map((x) => {
            return new GetFunktionsbereichAufgabenBenutzerBerechtigungenAction(x.payload);
        })));

    benutzerHinzufuegen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<BenutzerberechtigungenHinzufuegenAction>(BENUTZER_BERECHTIGUNGEN_HINZUFUEGEN),
        withLatestFrom(this.store$.pipe(select(getSelectedAufgaben))),
        filter(([x, selectedAufgaben]) => x.payload !== null && x.payload.length > 0
            && selectedAufgaben !== null && selectedAufgaben.length > 0),
        map(([x, selectedAufgaben]) => {
            const request = <AufgabenBenutzerIdsRequest> {
                benutzer_id_liste: x.payload,
                aufgabe_id_liste: selectedAufgaben
            };
            return new PostAufgabenBenutzerBerechtigungenHinzufuegenAction(request);
        })
    ));

    benutzerEntfernen$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<BenutzerberechtigungenEntfernenAction>(BENUTZER_BERECHTIGUNGEN_ENTFERNEN),
        withLatestFrom(this.store$.pipe(select(getSelectedAufgaben))),
        filter(([x, selectedAufgaben]) => selectedAufgaben !== null && selectedAufgaben.length > 0),
        map(([x, selectedAufgaben]) => {
            const request = <AufgabenBenutzerIdsRequest> {
                benutzer_id_liste: [x.payload.benutzer_id],
                aufgabe_id_liste: selectedAufgaben
            };
            return new PostAufgabenBenutzerBerechtigungenEntfernenAction(request);
        })
    ));

    constructor(private actions$: Actions,
                private store$: Store<any>,
                public route: ActivatedRoute,
                public router: Router) {
    }
}
